module.exports = __webpack_public_path__ + "img/appAsset-agents-avatar-1.c5954b9f.jpg";